<template>
  <div id="app" class="ion-padding">
<form  @submit="onSubmit" >

    <h1>Box {{ editBox.title }}</h1>

    <ion-item>
      <ion-label position="stacked">Titel <ion-text color="danger">*</ion-text></ion-label>
      <ion-input required :value="link.title" @ionInput="link.title = $event.target.value"></ion-input>
    </ion-item>


  <ion-item>
    <ion-label>Farbe</ion-label>
    <ion-select ok-text="Ok" cancel-text="Abbrechen"  :value="link.color" @ionChange="link.color = $event.target.value">
      <ion-select-option v-for="color in colors" :key="color.value" :value="color.value">{{ color.label }}</ion-select-option>
    </ion-select>
  </ion-item>

  <ion-item>
    <ion-label position="stacked">Url <ion-text color="danger">*</ion-text></ion-label>
    <ion-input required :value="link.href" @ionInput="link.href = $event.target.value"></ion-input>
  </ion-item>

  <a href="/#/box/list" class="link-button">Abbrechen</a>
  <ion-button type="submit">Speichern</ion-button>
</form>
  </div>
</template>

<script>

  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "LinkFields",
    props: ['modus', 'box', 'id'],
    data(){
      return {
        colors: [
          {
            label: 'default',
            value: 'default'
          },
          {
            label: 'gelb',
            value: 'yellow'
          },
          {
            label: 'grün',
            value: 'green'
          },
          {
            label: 'blau',
            value: 'blue'
          },
        ],
       }
    },

    methods: {
      ...mapActions(["addLink", "getLink", "updateLink", "getBox"]),
      onSubmit(e){
        e.preventDefault();
        if(this.modus === 'new') {
          this.addLink(this.link);
        } else {
          this.updateLink(this.link);
        }
        this.$router.push('/link/list/' + this.box);
      },
    },
    components: {

    },
    computed: {
      ...mapGetters(['editLink', 'editBox']),
      link(){
        if(this.modus === 'new') {
          return  {
            title: '',
            color: 'default',
            href: '',
            box: this.editBox.id
          }
        } else {
          return this.editLink;
        }
      }

    },
    created() {
      if(this.id) {
        this.getLink(this.id);
      }
      this.getBox(this.box);
    }
  };
</script>

<style scoped>

  ion-button {
    float: right;
    margin-top: 40px;
  }

</style>
